document.addEventListener("alpine:init", () => {
    Alpine.data("hero", () => ({
        active: null,
        tick: null,
        timeout: null,
        duration: 12000,
        autoAdvance: true,
        items: null,
        lotties: null,
        init() {
            this.lotties = this.$el.querySelectorAll(".Hero__lotties > div");
            this.items = this.$el.querySelectorAll(".Hero__item");
        },
        advanceItems() {
            this.i = 0;

            this.timeout;
            clearTimeout(this.timeout);

            this.advance = () => {
                if (this.autoAdvance) {
                    if (this.i < this.items.length) {
                        this.setItem(this.i);
                        clearTimeout(this.tick);
                        this.i++;
                        this.timeout = setTimeout(this.advance, this.duration);
                    } else {
                        clearTimeout(this.timeout);
                        this.i = 0;
                        this.advance();
                    }
                }
            };
            this.advance();
        },
        setItem(item) {
            this.active = item;
            const lottie = this.lotties[item].querySelector("lottie-player");

            setTimeout(() => {
                lottie.play();
            }, 200);
        },
        changeItem(item) {
            this.active = item;
            this.autoAdvance = false;

            const lottie = this.lotties[item].querySelector("lottie-player");

            setTimeout(() => {
                lottie.play();
            }, 200);
        },
    }));
});
